const comments = [
  {
    name: '漫画迷小A',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20warm%20friendly%20expression%2C%20soft%20coral%20and%20cream%20background%2C%20clean%20simple%20illustration%20style%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '这个网站真的太棒了！斗罗大陆更新速度超快，画质清晰，下拉式阅读体验满分。已经推荐给身边所有漫画朋友了！',
    comic: '《斗罗大陆》',
  },
  {
    name: '夜深了还不睡',
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20portrait%2C%20casual%20expression%2C%20soft%20amber%20and%20cream%20background%2C%20clean%20illustration%20style%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '终于找到了一个免费无删减的漫画站！之前在其他平台看的都是删减版，这里全本完整，太感动了。完美世界每一话都准时更新。',
    comic: '《完美世界》',
  },
  {
    name: '二次元老司机',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20man%20avatar%20portrait%2C%20confident%20smile%2C%20warm%20coral%20and%20cream%20background%2C%20clean%20illustration%20style%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '作为十年的老漫迷，羞羞歪歪漫画的品类真的很全。从热血到恋爱，从日漫到国漫，什么类型都有。而且分类索引做得特别好，找漫画很方便。',
    comic: '《一念永恒》',
  },
  {
    name: '每日签到党',
    time: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20portrait%2C%20blushing%20happy%20expression%2C%20warm%20amber%20and%20cream%20background%2C%20clean%20illustration%20style%2C%20profile%20picture%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish',
    text: '每天打开手机第一件事就是来羞羞歪歪漫画看更新。下拉式阅读真的比翻页爽太多了，一口气可以看好几话停不下来！',
    comic: '《大王饶命》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">来自真实读者的阅读体验与评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment) => (
            <article key={comment.name} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-2">{comment.text}</p>
              <span className="inline-block text-xs text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">{comment.comic}</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}